module.exports = __webpack_public_path__ + "static/img/computer-sm.17dbd5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/computer-sm.png
// module id = oVPG
// module chunks = 0